import PropTypes from 'prop-types'
import _ from 'lodash'

/**
 * Normal usage of the applicationNotifications should be via standard context e.g. the useApplicationNotifications hook.
 * This is a redux action and reducer that can be used to trigger notifications from within redux actions if needed.
 */

export const APPLICATION_NOTIFICATIONS_NOTIFY =
  'APPLICATION_NOTIFICATIONS_NOTIFY'
export const APPLICATION_NOTIFICATIONS_CLEAR = 'APPLICATION_NOTIFICATIONS_CLEAR'

// actions
export const applicationNotificationsNotify = notification => ({
  type: APPLICATION_NOTIFICATIONS_NOTIFY,
  notification,
})

export const applicationNotificationsClear = notification => ({
  type: APPLICATION_NOTIFICATIONS_CLEAR,
  notification,
})

/**
 * React component to trigger a notification based on redux state
 * @param {*} notification          // content of notification
 * @param {*} clearNotifications    // dispatches applicationNotificationsClear
 * @param {*} notificationsContext  // notifications context object
 * @param {*} notifierType          // e.g. toast, overlayBanner, etc.
 * @returns null                   // no need to display anything
 */
export const ApplicationNotificationsReduxNotifier = ({
  notification,
  clearNotifications,
  notificationsContext,
  notifierType = 'toast',
}) => {
  if (notification && !_.isEmpty(notification)) {
    notificationsContext?.[notifierType]?.open(_.cloneDeep(notification))
    clearNotifications()
  }
  return null
}

ApplicationNotificationsReduxNotifier.propTypes = {
  notification: PropTypes.object,
  clearNotifications: PropTypes.func,
  notificationsContext: PropTypes.object,
  notifierType: PropTypes.string,
}

export const applicationNotifications = (state = {}, action) => {
  switch (action.type) {
    case APPLICATION_NOTIFICATIONS_NOTIFY:
      return {
        ...state,
        ...action.notification,
      }
    case APPLICATION_NOTIFICATIONS_CLEAR:
      return {}
    default:
      return state
  }
}
